<template>
  <div class="youthTeam">
    <router-link :to="{name: 'youth'}" v-if="seasonType.mainYouth">
      <div class="bg">
        <div class="info">
          <p>전남드래곤즈의 <span>미래</span></p>
          <p class="title">YOUTH<span>TEAM</span></p>
        </div>
        <div class="team">
          <img src="@/assets/img/youth/youth_team_2024.png" alt="youth_team">
        </div>
        <div class="infoPc">
          <p class="title">YOUTH<span>TEAM</span></p>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>

export default {
  name : 'YouthTeam',
  data() {
    return {
      seasonType: this.$store.getters['getSeasonType'],
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
